import { Link } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export interface StatCardProps {
  title: string;
  value: number | undefined;
  loading: boolean;
  icon: React.ReactNode;
  to: string;
  tone?: 'neutral' | 'failure';
}

export function StatCard({ title, value, loading, icon, to, tone = 'neutral' }: StatCardProps) {
  return (
    <Link to={to}>
      <Card className="transition-colors hover:border-foreground/30">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-xs uppercase tracking-wide text-muted-foreground">
            {title}
          </CardTitle>
          <div className="text-muted-foreground">{icon}</div>
        </CardHeader>
        <CardContent>
          {loading ? (
            <Skeleton className="h-9 w-16" />
          ) : (
            <div
              className={
                tone === 'failure' && value && value > 0
                  ? 'text-3xl font-semibold text-red-700 dark:text-red-300'
                  : 'text-3xl font-semibold'
              }
            >
              {value ?? 0}
            </div>
          )}
        </CardContent>
      </Card>
    </Link>
  );
}
